// cobrancas-totais-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Exportar totais": "Exportar totales",
};

export default catalogo;
